import {GET_DATA, DATA_ERROR} from '../types';

const initialState = {
  users: [],
  loading: true,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_DATA:
      return {
        ...state,
        users: action.payload,
        loading: false,
      };
    case DATA_ERROR:
      return {
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};
